import {landline, mobile} from '@/utils/validate'
// import {textFormat} from '@/src/views/sheet/widget/types'
import {chinese, number1, english} from '@/utils/validate'
import {doubleNumber} from '@/utils/validate'
// import {inputField} from '@/views/sheetConfig/fieldConfig/format/index'
import {isUndef} from '@/utils/common'
// 必填校验
export function commonRule (item, priorityAuthority) {
  // 优先判断审批权限
  if (priorityAuthority && priorityAuthority === 'required') {
    return [{ required: true, message: '必填', trigger: 'change' }]
  } else if (priorityAuthority) {
    return []
  } 
  let v = item.validate || []
  if (v.includes(1)) {
    return [{ required: true, message: '必填', trigger: 'change' }]
  }
  return []
}
// 文本校验
// export function inputRule (item) {
//   let rules: any = []
//   if (item.fieldType === 'text') {
//     if (item.maxContentLength) {
//       rules.push({ type: 'string', max: item.maxContentLength, message: `最大长度不超过${item.maxContentLength}字符`, trigger: ['blur'] })
//     }
//     if (item.minContentLength) {
//       rules.push({ type: 'string', min: item.minContentLength, message: `最小长度不少于${item.minContentLength}字符`, trigger: ['blur'] })
//     }
//     if (item.format === textFormat.chinese) {
//       rules.push({ pattern: chinese, message: '仅中文', trigger: ['blur']})
//     } else if (item.format === textFormat.english) {
//       rules.push({ pattern: english, message: '仅英文', trigger: ['blur']})
//     } else if (item.format === textFormat.number) {
//       rules.push({ pattern: number1, message: '仅数字', trigger: ['blur']})
//     }
//   } else if (item.fieldType === 'email') {
//     rules.push({ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur']})
//   } else if (item.fieldType === 'phone') {
//     let pattern = item.phoneType === 1 ? mobile : landline
//     rules.push({ type: 'string', pattern, message: '请输入正确号码(区号-电话号码-分机号码)', trigger: ['blur']})
//   }
//   return rules
// }
const validatorFixed = (rule: any, value: string, callback: any) => {
    if (!value) {
      callback()
    }
    if ((Number(value).toFixed(rule.decimalPoint) !== value)) {
      callback(new Error('小数点后保留' + rule.decimalPoint + '位'))
    } else {
      callback()
    }
  }
const validatorRange = (rule: any, value: string, callback: any) => {
    if (!value) {
      callback()
    }
    if (!isUndef(rule.maxNumber) && (value > rule.maxNumber)) {
      callback(new Error('最大值不超过' + rule.maxNumber))
    } else if (!isUndef(rule.minNumber) && (value < rule.minNumber)) {
      callback(new Error('最小值不小于' + rule.minNumber))
    } else {
      callback()
    }
  }
// 数字校验  
export function numberRule (item) {
  let rules: any = []
  let {numberRange, maxNumber, minNumber, decimalPoint} = item
  rules.push({ message: `必须为数字`, pattern: doubleNumber, trigger: ['blur'] })
  if (numberRange === 2) {
    rules.push({ trigger: 'blur', validator: validatorRange, maxNumber, minNumber })
  }
  rules.push({ trigger: 'blur', validator: validatorFixed, decimalPoint })
  return rules
}
/* 判断最后一个级是不是叶子节点 */
function isLeaf (ids, options) {
  ids = [...ids]
  for (let i = 0; i < options.length; i++) {
    let item = options[i]
    if (item.key === ids[0]) {
      ids.shift()
      if (!ids.length) {
        // 排除已删除节点
        return !(item.children || []).find((one) => one.isDelete !== 1)
      }
      return isLeaf(ids, item.children || [])
    }
  }
}
const validatorCascade = (value: string, rule: any) => {
  let field = rule.item
  if (value.length >= field.requireLevel) {
    return true
  } else {
    if (isLeaf(value, field.options)) {
      return true
    } else {
      return false
    }
  }
}
// 级联校验
export function cascadeRule (item, rules) {
  if (rules.length) {
    rules.push({ trigger: 'onBlur', validator: validatorCascade, item, message: item.requireLevel + '级必填' })
    return rules
  }
  return []
}
// export function itemToRule (item, priorityAuthority) {
//   let rules = commonRule(item, priorityAuthority)
//   if (inputField.includes(item.fieldType)) {
//     return rules.concat(inputRule(item))
//   } else if (item.fieldType === 'number') {
//     return rules.concat(numberRule(item))
//   } else if (item.fieldType === 'cascadeSelect') {
//     return cascadeRule(item, rules)
//   } else {
//     return rules
//   }
// }
